(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["notifications-drawer"] && !Shopify.designMode) return;
  try {
    
(function() {
  var STORAGE_KEY = 'notifications_seen_v1';

  function openDrawer() {
    document.querySelectorAll('[data-notifications-drawer]').forEach(function(el){
      el.classList.add('open');
      el.setAttribute('aria-hidden','false');
    });
    document.querySelectorAll('[data-notifications-drawer-overlay]').forEach(function(o){ o.classList.add('open'); o.setAttribute('aria-hidden','false'); });
    document.querySelectorAll('[data-notifications-drawer-toggle]').forEach(function(btn){ btn.setAttribute('aria-expanded','true'); });
  }
  function closeDrawer() {
    document.querySelectorAll('[data-notifications-drawer]').forEach(function(el){
      el.classList.remove('open');
      el.setAttribute('aria-hidden','true');
    });
    document.querySelectorAll('[data-notifications-drawer-overlay]').forEach(function(o){ o.classList.remove('open'); o.setAttribute('aria-hidden','true'); });
    document.querySelectorAll('[data-notifications-drawer-toggle]').forEach(function(btn){ btn.setAttribute('aria-expanded','false'); });
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-notifications-drawer-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); return; }

    if (e.target.closest('[data-notifications-drawer-close]') || e.target.closest('[data-notifications-drawer-overlay]')) {
      e.preventDefault(); closeDrawer(); return;
    }
  });

  function updateNotificationCount() {
    var items = document.querySelectorAll('[data-notification-item]');
    var count = items.length;
    var hasSeen = false;

    try {
      hasSeen = window.localStorage && window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch(e) {
      hasSeen = false;
    }

    document.querySelectorAll('[data-notifications-count]').forEach(function(badge) {
      if (!badge) return;

      if (!hasSeen && count > 0) {
        badge.textContent = count;
        badge.classList.add('is-visible');
      } else {
        badge.textContent = '';
        badge.classList.remove('is-visible');
      }
    });

    document.querySelectorAll('[data-notifications-heading-count]').forEach(function(el) {
      if (!el) return;

      if (count > 0) {
        el.textContent = count + ' NEW';
      } else {
        el.textContent = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateNotificationCount);
  } else {
    updateNotificationCount();
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-notifications-drawer-toggle]');
    if (toggle) {
      try {
        if (window.localStorage) {
          window.localStorage.setItem(STORAGE_KEY, '1');
        }
      } catch(err) {}
      // re-run to hide badge after first open
      updateNotificationCount();
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { closeDrawer(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
